import { useQuery } from '@tanstack/react-query';

import { getProductConfiguration } from '~/controllers/productConfigurations';
import { translateRuleConditionToJmespath } from '~/domain/configurationRule';
import { isPartOfEim } from '~/domain/features';
import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';
import { IConfigurationRule } from '~/domain/IConfigurationRule';
import { IProductConfiguration } from '~/domain/IProductConfiguration';
import { useRequest } from '~/hooks/useRequestQuery';
import { CACHE_TIME_2HR, STALE_TIME_2HR } from '~/queryCache';

const filterRulesByPackSets = (packSets: IConfigurationOptionGroup[]) => {
  return (rule: IConfigurationRule) => {
    const packSet = packSets.find(packSet => packSet.code === rule.packSetCode);
    if (packSet) {
      const pack = packSet.packs.find(pack => pack.code === rule.packCode);
      return !!pack;
    }
    return false;
  };
}
const translateConfig = (config: IProductConfiguration) => {
  const { packSets = [], rules = [], cameras } = config || {};
  const translatedRules: IConfigurationRule[] = rules.filter(filterRulesByPackSets(packSets)).map(translateRuleConditionToJmespath);
  const eimPackSets = packSets.filter(x => isPartOfEim(x));
  const nonEimPackSets = packSets.filter(x => !isPartOfEim(x));
  
  return {
    ...config,
    rules: translatedRules,
    eimPackSets,
    nonEimPackSets,
    cameras,
  };
}

export const useProductConfigurationQuery = () => {
  const request = useRequest();
  const requestId = request?.requestId;
  //const market = request?.addressableRegion?.value;
  //const vehicle = request?.vehicleModel?.value;
  const result = useQuery(
    ['getProductConfiguration', { requestId }],
    getProductConfiguration,
    {
      enabled: !!requestId,
      cacheTime: CACHE_TIME_2HR,
      staleTime: STALE_TIME_2HR,
      refetchOnMount: false,
      refetchOnReconnect: false,
      keepPreviousData: true,
      select: translateConfig,
    });
  
  return result;
  // return useQuery(
  //   ['getProductConfiguration', { requestId }],
  //   getProductConfiguration,
  //   {
  //     enabled: !!requestId,
  //     cacheTime: CACHE_TIME_2HR,
  //     staleTime: STALE_TIME_2HR,
  //     refetchOnMount: false,
  //     refetchOnReconnect: false,
  //     keepPreviousData: true,
  //     select: translateConfig,
  //   });
}
